module.exports = __webpack_public_path__ + "media/images/reports/info_white-3f029dc0ebecac6466211d51c4289879.svg";